import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {useHistory} from "react-router";

const links = (links, history) => links.map((link, key) => <div key={key}>
    <li>
        <a className="text-white" style={{
            cursor: "pointer"
        }} onClick={() => link.redirect.includes("http")
            ? window.open(link.redirect)
            : history.push(link.redirect)}> { link.content
        }</a>
    </li>
</div>)
const putIcons = (icons) => <div>
    {icons.map((obj, key) =>
        <a key={key} href={ obj.redirect } className="links-iconos" target={ obj.target }>
            <img src={ obj.imageUrl }
                 width="30" height="30" className="m-1 img" alt="image"/>
        </a>
    )}
</div>
const putMainTitle = (title) => <h6 className="text-uppercase mt-3 mb-4 text-white font-weight-bold">{ title }</h6>

const Footer = props => {
        const { leftColumn, centerColumn, rightColumn, dark } = props;
        const history = useHistory();
        return (
            <div>
                <footer style={{
                    backgroundColor: dark? "#001C41" : "#0f69b4"
                }}>
                    <div className="container text-center text-md-left"s>
                        <div className="row ">
                            <div className="col-md-4 mx-auto mt-5">
                                {!!leftColumn.mainTitle && putMainTitle(leftColumn.mainTitle)}
                                <ul className="list-unstyled">
                                    {!!leftColumn.icons && putIcons(leftColumn.icons)}
                                    {!!leftColumn.link && links(leftColumn.link, history)}
                                </ul>
                            </div>
                            <hr className="clearfix w-100 d-md-none"/>
                            <div className="col-md-4 mx-auto">
                                {centerColumn.mainTitle && putMainTitle(centerColumn.mainTitle)}
                                <ul className="list-unstyled">
                                    {!!centerColumn.icons && putIcons(centerColumn.icons)}
                                    {!!centerColumn.link && links(centerColumn.link)}
                                </ul>
                            </div>
                            <hr className="clearfix w-100 d-md-none"/>
                            <div className="col-md-4 mx-auto">
                                {rightColumn.mainTitle && putMainTitle(rightColumn.mainTitle)}
                                <ul className="list-unstyled">
                                    {!!rightColumn.icons && putIcons(rightColumn.icons)}
                                    {!!rightColumn.link && links(rightColumn.link)}
                                </ul>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        );
}

Footer.propTypes = {
    leftColumn : PropTypes.object,
    centerColumn: PropTypes.object,
    rightColumn: PropTypes.object
};

Footer.defaultProps = {
    "leftColumn": {
        "mainTitle": "",
        "icons": []
    },
    "centerColumn":
        {
            "mainTitle": "",
            "link": []
        },
    "rightColumn":
        {
            "mainTitle": "",
            "link": []
        }
}

const mapStateToProps = state => ({
   dark : state.dark
});

export default connect(mapStateToProps,{})(Footer);
